import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/pillarArticles';

export default function PillarSection() {
  const { t } = useTranslation();

  return (
    <section id="pillars" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t('home.pillars.title')}
          </h2>
          <p className="mt-3 text-base text-foreground-600">{t('home.pillars.subtitle')}</p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.key}
              to="/usfans-spreadsheet-guide"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-0.5 hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden md:h-44">
                <img
                  src={article.image}
                  alt={t(`home.pillars.items.${article.key}.title`)}
                  title={`${t(`home.pillars.items.${article.key}.title`)} - USFans Spreadsheet`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs font-medium text-foreground-500">
                  <span className="rounded-full bg-primary-100 px-2.5 py-1 text-primary-800">{t('home.pillars.label')}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {article.readingTime} {t('home.pillars.minRead')}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-700">
                  {t(`home.pillars.items.${article.key}.title`)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {t(`home.pillars.items.${article.key}.summary`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-700">
                  {t('home.pillars.readMore')}
                  <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}